import { render, staticRenderFns } from "./resultsimport.vue?vue&type=template&id=67784ae2"
import script from "./resultsimport.vue?vue&type=script&lang=js"
export * from "./resultsimport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports